<template>
  <button 
    :class="[
      `btn-color-${color}`,
      `btn-size-${size}`,
      {
        'btn-stretch': stretch
      }
    ]" :disabled="disabled"
  >

    <slot />
    <div class="icon" v-if="$slots.icon" :class="{
      'icon-only': !$slots.default
    }">
      <slot name="icon" />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      validator: (v)=> {
        return [
          'primary',
          'secondary',
          'accent',
          'default',
          'ghost',
          'positive'
        ].includes(v)
      },
      default: 'primary',
    },
    stretch: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: (v)=> {
        return ['small', 'medium', 'large'].includes(v)
      },  
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  } 
}
</script>

<style lang="scss" scoped>

button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: var(--btn-size);
  line-height: var(--btn-size);
  font-size: var(--btn-font-size);
  font-weight: 600;
  font-family: 'Red Hat Display';
  color: var(--btn-font-color);
  background-color: var(--btn-bg-color);
  border: 1px solid var(--btn-border-color);
  border-radius: 8px;
  padding: 0 var(--btn-gap);
}

button .icon {
  margin-left: 16px;
  &.icon-only {
    margin: 0;
  }
  &:deep(svg) {
    display: block;
    fill: var(--btn-icon-color);
  }
  &:deep(svg path) {
    fill: var(--btn-icon-color);
  }
}

.btn-size-small {
  --btn-size: 44px;
  --btn-font-size: 16px;
  --btn-gap: 21px;
}

.btn-size-medium {
  --btn-size: 44px;
  --btn-font-size: 20px;
  --btn-gap: 25px;
}

.btn-size-large {
  --btn-size: 56px;
  --btn-font-size: 20px;
  --btn-gap: 41px;
}

.btn-color-primary {
  --btn-bg-color: var(--primary-500);
  --btn-border-color: var(--primary-500);
  --btn-icon-color: #FFF;
  &:hover {
    --btn-bg-color: var(--primary-600);
    --btn-border-color: var(--primary-600);
  }
  &:active {
    --btn-bg-color: var(--primary-700);
    --btn-border-color: var(--primary-700);
  }
  &[disabled] {
    --btn-bg-color: var(--gray-300);
    --btn-border-color: var(--gray-300);
    --btn-font-color: var(--gray-500);
    --btn-icon-color: var(--gray-500);
  }
}
.btn-color-positive {
  --btn-bg-color: var(--positive-500);
  --btn-border-color: var(--positive-500);
  --btn-icon-color: #FFF;
  &:hover {
    --btn-bg-color: var(--positive-600);
    --btn-border-color: var(--positive-600);
  }
  &:active {
    --btn-bg-color: var(--positive-700);
    --btn-border-color: var(--positive-700);
  }
  &[disabled] {
    --btn-bg-color: var(--gray-300);
    --btn-border-color: var(--gray-300);
    --btn-font-color: var(--gray-500);
    --btn-icon-color: var(--gray-500);
  }
}
.btn-color-secondary {
  --btn-bg-color: var(--gray-900);
  --btn-border-color: var(--gray-900);
  --btn-icon-color: white;
  &:hover {
    --btn-bg-color: var(--gray-800);
    --btn-border-color: var(--gray-800);
    --btn-icon-color: white;
  }
  &:active {
    --btn-bg-color: var(--gray-700);
    --btn-border-color: var(--gray-700);
    --btn-icon-color: white;
  }
}
.btn-color-accent {
  --btn-bg-color: white;
  --btn-border-color: var(--gray-400);
  --btn-font-color: var(--primary-500);
  --btn-icon-color: var(--gray-900);
  &:hover {
    --btn-bg-color: var(--primary-500);
    --btn-border-color: var(--primary-500);
    --btn-icon-color: #FFF;
    --btn-font-color: #FFF;
  }
  &:active {
    --btn-bg-color: var(--primary-600);
    --btn-border-color: var(--primary-600);
    --btn-icon-color: #FFF;
    --btn-font-color: #FFF;
  }
  &[disabled] {
    --btn-bg-color: var(--gray-100);
    --btn-border-color: var(--gray-300);
    --btn-font-color: var(--gray-500);
    --btn-icon-color: var(--gray-500);
  }
}
.btn-color-default {
  --btn-bg-color: white;
  --btn-border-color: var(--gray-400);
  --btn-font-color: var(--gray-900);
  &:hover {
    --btn-bg-color: var(--primary-500);
    --btn-border-color: var(--primary-500);
    --btn-font-color: #FFF;
  }
  &:active {
    --btn-bg-color: var(--primary-600);
    --btn-border-color: var(--primary-600);
    --btn-font-color: #FFF;
  }
}

.btn-stretch {
  width: 100%;
  flex: 1;
}

</style>